import { tryGet, tryPost, tryPut, tryDelete } from './index';

export const getValveDeficiencies = async () => {
  console.log('Getting Valve Deficiencies');
  const result = await tryGet(`/valveDeficiencies`);
  console.log('Valve Deficiencies', result);
  return result.data;
};

export const getValveDeficienciesByValveId = async (valveId) => {
  console.log('Getting Valve Deficiencies by Valve ID:', valveId);
  const result = await tryGet(`/valveDeficiencies/byValveId/${valveId}`);
  console.log('Valve Deficiencies', result);
  return result.data;
};

export const getValveDeficiency = async (valveDeficiencyId) => {
  const result = await tryGet(`/valveDeficiencies/${valveDeficiencyId}`);
  return result.data;
};

export const getValveDeficiencyEdit = async (valveDeficiencyId) => {
  const result = await tryGet(`/valveDeficiencies/${valveDeficiencyId}/edit`);
  return result.data;
};

export const updateValveDeficiency = async (valveDeficiency) => {
  const result = await tryPut(`/valveDeficiencies`, valveDeficiency);
  return result.data;
};

export const addValveDeficiency = async (valveDeficiency) => {
  const result = await tryPost(`/valveDeficiencies`, valveDeficiency);
  return result.data;
};

export const deleteValveDeficiency = async (valveDeficiencyId) => {
  const result = await tryDelete(`/valveDeficiencies/${valveDeficiencyId}`);
  return result.data;
};